import { BookingSlot, BookingStatus } from '../utils/entities/type';
import {
  IBooking,
  ICreateBooking,
  ICreateServiceDetails,
  OrderItem,
} from '../utils/entities/interface';

import { get, post } from './https';

export interface Pagination {
  totalCount: number;
  page: number;
  limit: number;
  totalPages: number;
  totalRecords: number;
}

interface BookingListResponse {
  status: boolean;
  data: IBooking[];
  count: number;
  pagination: Pagination;
}

const GETBookings = async ({
  page = 1,
  limit = 10,
  searchQuery = '',
  sortField = 'name',
  sortOrder = 'ASC',
  status,
  startDate,
  endDate,
  equipmentType,
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
  status?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  equipmentType?: string;
}): Promise<BookingListResponse> => {
  let url = `/api/v1/admin/booking/list?limit=${limit}&page=${page}`;
  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }
  if (sortField && sortField !== 'name') {
    url += `&sortby=${sortField}`;
  }
  if (sortOrder && sortOrder !== 'ASC') {
    url += `&orderby=${sortOrder}`;
  }
  if (status) {
    url += `&filters=${status}`;
  }
  if (equipmentType) {
    url += `&equipmentType=${equipmentType}`;
  }

  if (startDate && endDate) {
    url += `&startDate=${startDate.toISOString().split('T')[0]}&endDate=${endDate.toISOString().split('T')[0]}`;
  } else if (startDate) {
    url += `&startDate=${startDate.toISOString().split('T')[0]}`;
  } else if (endDate) {
    url += `&endDate=${endDate.toISOString().split('T')[0]}`;
  }

  const response = await post(url);
  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch users');
  }
};

interface BookingDetailResponse {
  status: boolean;
  data: IBooking;
}

const GETBookingById = async (
  bookingId: string,
): Promise<BookingDetailResponse> => {
  const url = `/api/v1/admin/booking/${bookingId}`;
  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch booking details');
  }
};

const AssignTechnician = async (
  bookingId: string,
  technicianId: string,
): Promise<number> => {
  const url = `/api/v1/admin/booking/assign_technician`;
  const response = await post(url, {
    bookingId,
    technicianId,
  });
  if (response.status == 200) {
    return 200;
  } else {
    throw new Error('Failed to Assign Technician to Booking');
  }
};

const UpdateOrderItem = async (id: string, Items: OrderItem[]) => {
  const url = `/api/v1/admin/booking/order-items/add-edit`;
  const response = await post(url, {
    bookingId: id,
    isUpdating: 1,
    orderItem: Items,
  });

  if (response.status == 200) {
    return 200;
  } else {
    throw Error('Error While Updateting OrderItems ');
  }
};
const NewBooking = async ({
  user_id,
  serviceDetails,
  addressId,
  slot,
  date,
  amount,
  name,
}: ICreateBooking) => {
  const url = `/api/v1/admin/booking/create`;

  const result = await post(url, {
    user_id,
    serviceDetails,
    addressId,
    slot,
    date,
    amount,
    name,
  });
  if (result.status == 201) {
    return 201;
  } else {
    throw new Error('Failed to Create New Booking');
  }
};
// const { serviceDetails, addressId, slot, date, amount } = req.body;
// service_id: { type: mongoose.Types.ObjectId, ref: 'Service', required: true },
// serviceType: String,
// quantity: String,
// acType: {
//     type: String, default: ''
// },
// place: {
//     type: String, default: ''
// },
// otherService: {
//     type: String, default: ''
// },
// comment: {
//     type: String, default: ''
// },
// services: [],
const EditBooking = async ({
  bookingId,
  serviceDetails,
  addressId,
  slot,
  date,
  amount,
}: {
  bookingId: string;
  addressId: string;
  serviceDetails: ICreateServiceDetails[];
  slot: BookingSlot;
  date: string;
  amount: any;
}): Promise<number> => {
  const url = `/api/v1/admin/booking/edit/${bookingId}`;
  const result = await post(url, {
    serviceDetails,
    addressId,
    slot,
    date,
    amount,
  });

  if (result.status == 200) {
    return 200;
  } else {
    throw Error('Failed while updating Booking');
  }
};
const GenerateInvoice = async (
  bookingId: string,
): Promise<string | undefined> => {
  try {
    if (!bookingId) {
      throw new Error('Booking ID is required');
    }

    const response = await get(
      `/api/v1/admin/booking/generate-invoice/${bookingId}`,
    );

    if (response.status !== 200) {
      throw new Error(response.data?.message || 'Failed to generate invoice');
    }
    return response.data?.url as string | undefined;
  } catch (error) {
    // Narrowing down the error type to handle different cases
    if (error instanceof Error) {
      console.error('Error generating invoice:', error.message);
    } else {
      console.error('Unexpected error generating invoice:', error);
    }
    throw error; // Rethrow the error after logging it
  }
};

const UpdateBookingStatus = async (
  bookingId: string,
  status: BookingStatus,
  reason?: string,
): Promise<number> => {
  const url = `/api/v1/admin/booking/status/manage`;
  const result = await post(url, { bookingId, status, reason });
  if (result.status == 200) {
    return 200;
  } else {
    throw Error('Failed To Update KYC Status');
  }
};
export {
  GETBookings,
  GETBookingById,
  AssignTechnician,
  NewBooking,
  GenerateInvoice,
  UpdateBookingStatus,
  EditBooking,
  UpdateOrderItem,
};
